// Feature definitions for the main application
export const AVAILABLE_FEATURES = [
  {
    key: "minisite",
    title: "Create your FREE Minisite",
    description:
      "Create and manage your digital business profile. Edit and update your information easily.",
    isFree: true,
    isComingSoon: false,
  },
  {
    key: "review-generator",
    title: "Google Review AI Assistant",
    description:
      "Create ready-to-post Google reviews with AI and boost your business reputation.",
    isFree: false,
    isComingSoon: false,
  },
  {
    key: "seo",
    title: "AI SEO",
    description: "Access AI SEO tools to improve your online visibility.",
    isFree: false,
    isComingSoon: false,
  },
  // {
  //   key: "ai-analytics",
  //   title: "AI Based Analytics",
  //   description:
  //     "Get intelligent insights and analytics powered by artificial intelligence.",
  //   isFree: false,
  //   isComingSoon: true,
  // },
  // {
  //   key: "custom-domain",
  //   title: "Custom Domain",
  //   description: "Use your own domain name for your business profile.",
  //   isFree: false,
  //   isComingSoon: true,
  // },
  // {
  //   key: "google-score-checker",
  //   title: "AI-Based Google Business Profile Score Checker",
  //   description:
  //     "Check and improve your Google Business Profile score with AI insights.",
  //   isFree: false,
  //   isComingSoon: true,
  // },
  // {
  //   key: "daily-offers",
  //   title: "Daily Offers Display",
  //   description:
  //     "Showcase your daily offers and promotions to attract more customers.",
  //   isFree: false,
  //   isComingSoon: true,
  // },
  // {
  //   key: "whatsapp-integration",
  //   title: "WhatsApp Integration",
  //   description:
  //     "Integrate WhatsApp messaging directly into your business profile.",
  //   isFree: false,
  //   isComingSoon: true,
  // },
  // {
  //   key: "rewards-app",
  //   title: "Rewards App Integration",
  //   description: "Integrate loyalty and rewards programs to retain customers.",
  //   isFree: false,
  //   isComingSoon: true,
  // },
];

/**
 * Get feature by key
 * @param {string} key - The feature key
 * @returns {Object|null} - The feature object or null if not found
 */
export const getFeatureByKey = (key) => {
  return AVAILABLE_FEATURES.find((feature) => feature.key === key);
};

/**
 * Check if a user has access to a specific feature
 * @param {string} featureKey - The feature key to check
 * @param {Array} userFeatures - Array of feature keys the user has access to
 * @returns {boolean} - Whether the user has access to the feature
 */
export const hasFeatureAccess = (featureKey, userFeatures = []) => {
  const feature = getFeatureByKey(featureKey);
  if (!feature) return false;

  // Free features are always available
  if (feature.isFree) return true;

  // Check if user has the feature in their paidWidgets array
  return userFeatures.includes(featureKey);
};

/**
 * Get all features a user has access to (including free features)
 * @param {Array} userFeatures - Array of feature keys the user has access to
 * @returns {Array} - Array of feature objects the user can access
 */
export const getUserAccessibleFeatures = (userFeatures = []) => {
  return AVAILABLE_FEATURES.filter((feature) => {
    if (feature.isFree) return true;
    return userFeatures.includes(feature.key);
  });
};

/**
 * Get features that require purchase
 * @returns {Array} - Array of premium feature objects
 */
export const getPremiumFeatures = () => {
  return AVAILABLE_FEATURES.filter(
    (feature) => !feature.isFree && !feature.isComingSoon
  );
};

/**
 * Get coming soon features
 * @returns {Array} - Array of coming soon feature objects
 */
export const getComingSoonFeatures = () => {
  return AVAILABLE_FEATURES.filter((feature) => feature.isComingSoon);
};

// Free plan usage limits (per period, e.g. monthly)
export const FREE_PLAN_LIMITS = {
  feedbackViews: 3,
  aiReviews: 10,
  extensionResponses: 3,
};

export const USAGE_FEATURE_KEYS = ["feedbackViews", "aiReviews", "extensionResponses"];

/**
 * Get usage limit for a plan
 * @param {string} plan - free | essential | pro
 * @returns {Object} - Limits per key; essential/pro have null (unlimited)
 */
export const getUsageLimits = (plan) => {
  if (plan === "essential" || plan === "pro") {
    return { feedbackViews: null, aiReviews: null, extensionResponses: null };
  }
  return { ...FREE_PLAN_LIMITS };
};

/**
 * Check if user has usage left for a feature (Free plan only)
 * @param {string} plan - User's plan
 * @param {Object} usage - { feedbackViews, aiReviews, extensionResponses }
 * @param {string} featureKey - feedbackViews | aiReviews | extensionResponses
 * @returns {{ allowed: boolean, used: number, limit: number, remaining: number }}
 */
export const checkUsageLimit = (plan, usage = {}, featureKey) => {
  const limits = getUsageLimits(plan);
  const limit = limits[featureKey];
  if (limit == null) return { allowed: true, used: 0, limit: Infinity, remaining: Infinity };
  const used = Number(usage[featureKey]) || 0;
  const remaining = Math.max(0, limit - used);
  return { allowed: remaining > 0, used, limit, remaining };
};
